import axios from 'axios';
import crud from "./crud";

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'projectkredit';
export default {
    listbyuser(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.get(`${baseurl}/listbyuser`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
}